import type { ReactNode } from "react";
import { STATIC_DEMO_MESSAGES } from "@/lib/ui-labels";
import { useMutation } from "@tanstack/react-query";
import { AuthContext } from "@/hooks/use-auth";
import type { RoleKey } from "@/lib/constants";
import { DEMO_USER_DEFINITIONS } from "@shared/platform/demo-fixture-data";
import type { InsertUser, User as SelectUser } from "@shared/platform/schema";

const DEMO_ACCESS_TOKEN = "static-demo-fixture-token";
const NOT_AVAILABLE_MESSAGE = STATIC_DEMO_MESSAGES.writeBlockedDescription;
const UNCHECKED_PLACEHOLDER_PASSWORD = "static-demo-user";

interface StaticDemoAuthProviderProps {
  role: RoleKey;
  children: ReactNode;
}

export function StaticDemoAuthProvider({ role, children }: StaticDemoAuthProviderProps) {
  const definition = DEMO_USER_DEFINITIONS[role];
  const user: SelectUser = {
    id: definition.id,
    email: definition.email,
    name: definition.name,
    role: definition.role,
    password: UNCHECKED_PLACEHOLDER_PASSWORD,
    supabase_id: null,
    tenantId: 1,
    lastLoginAt: null,
  };

  const loginMutation = useMutation<SelectUser, Error, { email: string; password: string }>({
    mutationFn: async () => {
      throw new Error(NOT_AVAILABLE_MESSAGE);
    },
  });
  const registerMutation = useMutation<SelectUser, Error, InsertUser>({
    mutationFn: async () => {
      throw new Error(NOT_AVAILABLE_MESSAGE);
    },
  });
  const logoutMutation = useMutation<void, Error, void>({
    mutationFn: async () => undefined,
  });

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading: false,
        error: null,
        loginMutation,
        logoutMutation,
        registerMutation,
        supabaseUser: null,
        accessToken: DEMO_ACCESS_TOKEN,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
